// components/DebugKeyListener.tsx
import { debugModeAtom } from "@/atoms/debugModeAtom";
import { useAtom } from "jotai";
import { useEffect } from "react";

const DebugKeyListener = () => {
  const [debug, setDebug] = useAtom(debugModeAtom);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // 例: Alt + D でトグル
      if (event.ctrlKey && event.key.toLowerCase() === "d") {
        setDebug((prev) => !prev);
        console.log(`[DEBUG MODE] ${!debug ? "ON" : "OFF"}`);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [debug, setDebug]);

  return null;
};

export default DebugKeyListener;
